import { gsap, ScrollTrigger, Power4 } from "gsap/all";
import Swup from 'swup';
import SwupJsPlugin from '@swup/js-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupGiaPlugin from '@swup/gia-plugin';
import DebugPlugin from '@swup/debug-plugin';
import components from './components'

gsap.registerPlugin(ScrollTrigger);

export default class pageTransition {
  
  
  constructor() {}
  
  static init() {
    
    const $main = document.querySelector('#swup')
    const $animation = document.querySelector('.page-animation-wrapper')
    
    
    const $frameBlack = document.querySelector('.page-transition__black');
    const $frameWhite = document.querySelector('.page-transition__white');
    const $framePrimary = document.querySelector('.page-transition__primary');
    const $frameSecondary = document.querySelector('.page-transition__secondary');
    const $logo = document.querySelector('.transition-logo');
    
    
    
    const transitions = [{
      from: '(.*)',
      to: '(.*)',
      in: function (next) {
        next()
        const tl = gsap.timeline({
          onComplete: next,
          delay: 0.4,
          defaults: {
            duration: 0.3,
            ease: Power4.easeOut,
            transformOrigin: 'right',
          }
        })
        tl
          .to($logo, { opacity: 0 })
          .to($framePrimary, { scaleX: 0 })
          .to($frameBlack, { scaleX: 0 }, "=-0.2")
      },
      out: (next) => {
        const tl = gsap.timeline({
          onComplete: next,
          defaults: {
            duration: 0.3,
            ease: Power4.easeIn,
            transformOrigin: 'left',
          }
        })
        tl
          .to($frameBlack, { scaleX: 1 })
          .to($framePrimary, { scaleX: 1 }, "=-0.2")
          .to($logo, { opacity: 1 })
        
        
      }
    }];
    
    const options = {
      animateHistoryBrowsing: true,
      plugins: [
        new SwupJsPlugin(transitions),
        new SwupBodyClassPlugin(),
        new SwupGiaPlugin({ components }),
        // new DebugPlugin()
      ]
    }
    
    const swup = new Swup(options)
    swup.on('clickLink', function(){ window.scrollTo(0, 0)});
    swup.on('contentReplaced', this.rerun);
    
    this.scrolly();
    // this.parallax(); 
    
  }
  
  static scrolly() {
    const scrollyObjects = document.querySelectorAll('[data-scrolly]');
    if (scrollyObjects.length > 0) {
      gsap.utils.toArray('[data-scrolly]').forEach((section, index) => {
        const w = section.querySelector('.scrolly-wrapper');
        const [x, xEnd] = (index % 2) ? ['15%', (w.scrollWidth - section.offsetWidth) * -0.1] : [w.scrollWidth * -0.1, 0];
        gsap.fromTo(w, { x }, {
          x: xEnd,
          scrollTrigger: {
            trigger: section,
            scrub: .5,
            ease: 'power3.out'
          }
        });
      });
    }
  }

  static fader() {
    const animateTargets = gsap.utils.toArray('[data-fader]');
    animateTargets.forEach((t, i) => {
      const anim = gsap.fromTo(t, { autoAlpha: 0, y: 50 }, { duration: .6, autoAlpha: 1, y: 0 });
      ScrollTrigger.create({
        trigger: t,
        animation: anim,
        toggleActions: 'play none none none',
        once: true,
      });
    });
  }

  // static parallax() {
  //   const parallaxTargets = gsap.utils.toArray('.wp-block-image.is-style-image-shadow');
    
  //   if (window.innerWidth > 768) {
  //     parallaxTargets.forEach((pt, i) => {
  //       const anim = gsap.to(pt, {
  //         yPercent: -30,
  //         ease: 'power3.out',
  //         scrollTrigger: {
  //           trigger: pt,
  //           // start: "top bottom", // the default values
  //           // end: "bottom top",
  //           scrub: true
  //         },
  //       });
  //     });
  //   }
  // }
  
  static rerun() {
    window.scrollTo(0, 0);
    pageTransition.scrolly();
    // pageTransition.fader();
    // pageTransition.parallax();
  }
}